import React from "react";

export const Show = ({ children }) => {
  let when = null;
  let otherwise = null;

  React.Children.toArray(children).forEach((child) => {
    if (child.type === Show.When && child.props.isTrue) {
      when = child.props.children;
    } else if (child.type === Show.Else) {
      otherwise = child.props.children;
    }
  });

  return when !== null ? when : otherwise;
};

Show.When = ({ isTrue, children }) => (isTrue ? children : null);

Show.Else = ({ children }) => children;
